import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import ClearButton from './ClearButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Body = styled('div').withConfig({
  displayName: "NoTicketsFoundMessage__Body",
  componentId: "sc-1am1n6-0"
})(["margin:0 auto 0 auto;width:220px;"]);
const MessageImage = styled(UIIllustration).withConfig({
  displayName: "NoTicketsFoundMessage__MessageImage",
  componentId: "sc-1am1n6-1"
})(["margin-bottom:20px;"]);

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message

function NoTicketsFoundMessage(props) {
  return /*#__PURE__*/_jsxs(UIResultsMessage, {
    Body: Body,
    illustration: "empty-state-charts",
    illustrationProps: {
      width: props.isLong ? 120 : 90,
      margin: 0
    },
    Image: MessageImage,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "no-tickets-found-message",
      message: "app.common.noTicketsFound"
    }), /*#__PURE__*/_jsx("br", {}), props.isLong ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "no-tickets-found-message-extra",
          message: "app.common.noTicketsFoundExtra"
        })
      }), /*#__PURE__*/_jsx("br", {})]
    }) : null, /*#__PURE__*/_jsx("div", {
      className: "m-top-4",
      children: /*#__PURE__*/_jsx(ClearButton, {})
    })]
  });
}
NoTicketsFoundMessage.propTypes = {
  isLong: PropTypes.bool
};
NoTicketsFoundMessage.defaultProps = {
  isLong: false
};
export default /*#__PURE__*/memo(NoTicketsFoundMessage);